define('plugin/product/view/ProductCategoryListView',['require','lib/view/BaseCollectionView','plugin/product/view/ProductCategoryItemView','plugin/product/view/ProductCategoryEmptyView'],function (require) {

    var Parent = require('lib/view/BaseCollectionView');
    var ProductCategoryItemView = require('plugin/product/view/ProductCategoryItemView');
    var ProductCategoryEmptyView = require('plugin/product/view/ProductCategoryEmptyView');

    return Parent.extend({

        emptyView: ProductCategoryEmptyView,
        childView: ProductCategoryItemView,
        collectionEvents: {
            'sync': 'safeRender'
        },

        safeRender: function (event) {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        onAttach: function () {
            this.triggerPageShown();
        },

        onDomRefresh: function () {
            this.triggerPageShown();
        },

        triggerPageShown: function() {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'product_category'
            });
        }
        
    });

});
